<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>视频管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.title" autocomplete="off" maxlength="30" placeholder="视频标题"
							clearable @change="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange" size="mini">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增视频</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="title" label="视频标题" align="center" />
			<el-table-column prop="video_id" label="视频ID" align="center" />
			<el-table-column label="视频分类" align="center">
				<template slot-scope="scope">
					{{scope.row.category_names.join(',')}}
				</template>
			</el-table-column>
			<el-table-column label="使用日期" align="center">
				<template slot-scope="scope">
					{{scope.row.suit_time_begin}}<br>{{scope.row.suit_time_end}}
				</template>
			</el-table-column>
				<!-- <el-table-column prop="url" label="视频地址" align="center">
				<template slot-scope="scope">
					<a :href="scope.row.url" target="_blank" style="color: #409eff">{{
            scope.row.url
          }}</a>
				</template>
			</el-table-column> -->
				<!-- <el-table-column prop="default_hot_num" label="视频封面" align="center">
				<template slot-scope="scope">
					<el-image style="width: 50px; height: 50px" :src="scope.row.video_img"
						:preview-src-list="[scope.row.video_img]">
						<div slot="error" class="image-slot">
							<span style="line-height: 50px">暂无</span>
						</div>
					</el-image>
				</template>
			</el-table-column> -->
				<!-- <el-table-column prop="default_hot_num" label="初始热度" align="center" /> -->
				<el-table-column prop="hot_num" label="点击热度" align="center" />
				<el-table-column prop="status" label="状态" align="center">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
							@change="changeStatus(scope.row)"></el-switch>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="260">
					<template slot-scope="scope">
						<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
							icon="el-icon-edit">
							修改
						</el-button>
						<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
							icon="el-icon-delete">
							移除
						</el-button>
					</template>
				</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="视频标题" prop="title">
							<el-input v-model="form.title" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="视频号视频ID" prop="video_id">
							<el-input v-model="form.video_id" autocomplete="off" placeholder="请输入视频号视频ID" />
						</el-form-item>
					</el-col>
					<!-- <el-col :span="24">
						<el-form-item label="初始热度" prop="default_hot_num">
							<el-input v-model="form.default_hot_num" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col> -->
					<el-col :span="24">
						<el-form-item label="适用小区" prop="xiaoqu_id">
							<el-select v-model="form.xiaoqu_id" placeholder="请选择" filterable multiple
								style="width: 100%">
								<el-option v-for="item in communityData" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="适用日期" prop="sy_date">
							<el-date-picker v-model="form.sy_date" format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" align="right"
								range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
								:picker-options="pickerOptions" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="资讯分类" prop="category_ids">
							<el-select v-model="form.category_ids" placeholder="请选择" style="width: 100%" filterable
								multiple>
								<el-option v-for="item in classArr" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="标签" prop="tag_ids">
							<el-select v-model="form.tag_ids" placeholder="请选择" style="width: 100%" filterable multiple>
								<el-option v-for="item in tagGroup" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="24">
						<el-form-item label="封面图片" required>
							<el-upload :action="uploadImgUrl" :headers="headers" :on-success="handleAvatarSuccess"
								:on-remove="handleRemove" :before-upload="beforeAvatarUpload" :show-file-list="false"
								:disabled="true">
								<div class="avatar-wrapper">
									<el-image :preview-src-list="[imageUrl]" v-if="imageUrl" :src="imageUrl"
										class="avatar" />
									<i v-if="imageUrl" class="el-icon-close" @click.stop="removePic"></i>
									<i v-else class="el-icon-picture-outline avatar-uploader-icon"
										@click="uploadPicIcon"></i>
								</div>
							</el-upload>
							<div style="color: #999; margin-top: 0vh">
								图片大小建议800*450
							</div>
							<div class="chooseImg">
								<el-button type="info" @click="chooseImg()">选择图片</el-button>
								<el-input v-model="imageUrl" autocomplete="off" placeholder="请输入图片地址" />
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="上传视频">
							<el-col :span="10">
								<el-upload class="avatar-uploader el-upload--text" :action="uploadImgUrl"
									:show-file-list="false" :on-success="handleVideoSuccess"
									:before-upload="beforeUploadVideo" :on-progress="uploadVideoProcess"
									:headers="headers">
									<video v-if="videoForm.storageurl != '' && videoFlag == false"
										:src="videoForm.storageurl" class="avatar" controls="controls">
										您的浏览器不支持视频播放
									</video>
									<i v-else-if="videoForm.storageurl == '' && videoFlag == false"
										class="el-icon-plus avatar-uploader-icon"></i>
									<el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent"
										style="margin-top: 30px"></el-progress>
								</el-upload>
							</el-col>
							<el-col :span="10">
								<el-button @click="handleRemove" size="mini">删除视频</el-button>
							</el-col>
							<el-input v-model="videoForm.storageurl" autocomplete="off" placeholder="请输入视频地址" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="视频时长">
							<el-input v-model="form.duration" autocomplete="off" />
						</el-form-item>
					</el-col> -->
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="copyTit" :visible.sync="copyIf" :close-on-click-modal="false" width="45%"
			class="dialogHeightX global-dialog-position" :before-close="copyout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: 10vh">
			<el-form ref="copyForm" :model="copyForm" label-width="100px" :rules="ruless">
				<el-row>
					<el-col :span="24">
						<el-form-item label="适用小区" prop="xiaoqu_id">
							<el-select v-model="copyForm.xiaoqu_id" placeholder="请选择" style="width: 100%" filterable>
								<el-option v-for="item in communityData" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="copySub">确 定</el-button>
				<!-- <el-button @click="getout">取 消</el-button> -->
			</div>
		</el-dialog>
		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -7vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
				<!-- <el-button @click="getout">取 消</el-button> -->
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getarticleList,
		addArticle,
		editArticle,
		deleteCity,
	} from "../../api/video";
	import {
		getclassifyList
	} from "../../api/classify";
	import {
		getcommunityList
	} from "../../api/community";
	import {
		getCookie
	} from "../../utils/util";
	// import { labelChildList } from "../../api/labelChild";
	import {
		tagSeleList
	} from "../../api/labelChild";
	import imgUpload from "../../components/uploadImg.vue";

	export default {
		mixins: [tableCommon],
		components: {
			imgUpload,
		},
		data() {
			return {
				upImg: false,
				dialogVisible: false,
				// 标签下拉列表
				tagGroup: [],
				regionTypes: [{
						label: 1,
						text: "显示",
					},
					{
						label: 0,
						text: "关闭",
					},
				],

				videoFlag: false,
				// 请求地址api
				api: {
					list: getarticleList,
					add: addArticle,
					del: deleteCity,
					edit: editArticle,
				},
				ruless: {
					xiaoqu_id: [{
						required: true,
						message: "请选择",
						trigger: "change",
					}, ],
				},
				// 规则验证
				rules: {
					title: [{
						required: true,
						message: "请输入名称",
						trigger: "blur",
					}, ],
					video_id: [{
						required: true,
						message: "请输入视频号视频ID",
						trigger: "blur",
					}],
					category_ids: [{
						required: true,
						message: "请选择分类",
						trigger: "change",
					}, ],
					xiaoqu_id: [{
						required: true,
						message: "请选择小区",
						trigger: "change",
					}, ],
					sy_date: [{
						required: true,
						message: "请选择时间范围",
						trigger: "change",
					}],
					tag_ids: [{
						required: true,
						message: "请选择标签",
						trigger: "change",
					}]
				},
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				videoForm: {
					storageurl: "",
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 分类数组
				classArr: [],
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
				},
				tableData: [],
				// 小区数组
				xiaoquArr: [],
				communityData: [],
				// 图片
				imageUrl: "",
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 图片上传地址
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				// 处理图片数组
				dealPic: [],
				imgFirst: false,
				copyForm: {},
				copyIf: false,
				copyTit: "",
			};
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
		},
		mounted() {
			this.getclassifyLists();
			this.getcommunityLists();
			this.labelChildLists();
		},
		methods: {
			changeDate() {
				this.$forceUpdate()
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			copyClick(res) {
				this.copyTit = res.title;
				this.copyForm = JSON.parse(JSON.stringify(res));
				this.copyForm.xiaoqu_id = "";
				if (this.copyForm.category_ids) {
					const stt = this.copyForm.category_ids.split(",").map(Number);
					this.copyForm.category_ids = stt;
				}
				if (this.copyForm.tag_ids) {
					const stts = this.copyForm.tag_ids.split(",").map(Number);
					this.copyForm.tag_ids = stts;
				}
				this.$nextTick(() => {
					this.imageUrl = res.video_img;
					this.videoForm.storageurl = res.url;
					this.$refs.copyForm.clearValidate();

					this.$forceUpdate();
				});
				this.actionType = "add";
				this.copyIf = true;
			},
			copySub() {
				this.$refs["copyForm"].validate((vaild, err) => {
					if (vaild) {
						delete this.copyForm.article_imgs;
						delete this.copyForm.xiaoqu_name;
						const str = this.copyForm.category_ids.join(",");
						this.copyForm.category_ids = str;
						if (this.copyForm.tag_ids) {
							const strs = this.copyForm.tag_ids.join(",");
							this.copyForm.tag_ids = strs;
						}
						this.copyForm.url = this.videoForm.storageurl;
						delete this.copyForm.created_at;
						addArticle(this.copyForm).then((res) => {
							this.addOrEditOpen = false;
							this.copyIf = false;
							this.$message.success("添加成功");
							this.initList();
						});
					}
				});
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.imageUrl = this.$refs.imgUpload.faData.url;
						this.form.video_img = this.imageUrl;
					}
					this.$refs.imgUpload.faData.url = "";
					this.$refs.imgUpload.getimgLists();
					this.upImg = false;
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseImg() {
				this.imgFirst = true;
				this.upImg = true;
			},
			// 标签下拉
			labelChildLists() {
				const select = {
					select: 1,
					type: 3,
				};
				tagSeleList(select).then((res) => {
					console.log(res, '数据1')
					this.tagGroup = res.data;
				});
			},
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				// this.handleEdit();
				this.actionType = "edit";
				delete this.form.article_imgs;
				delete this.form.xiaoqu_name;
				delete this.form.created_at;
				// const { city_name, company_name, ...rest } = this.form;
				// this.form = rest;
				editArticle(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
				});
			},
			// 移除图片
			removePic() {
				this.imageUrl = "";
				this.form.video_img = "";
			},
			// 验证视频格式
			beforeUploadVideo(file) {
				if (
					[
						"video/mp4",
						"video/ogg",
						"video/flv",
						"video/avi",
						"video/wmv",
						"video/rmvb",
					].indexOf(file.type) === -1
				) {
					this.$message.error("请上传正确的视频格式");
					return false;
				}
			},
			// 上传进度显示
			uploadVideoProcess(event, file, fileList) {
				this.videoFlag = true;
				this.videoUploadPercent = Math.floor(event.percent);
				console.log(this.videoUploadPercent);
			},
			// 获取上传图片地址
			handleVideoSuccess(res, file) {
				this.videoFlag = false;
				this.videoUploadPercent = 0;
				res.code === 200 ?
					(this.videoForm.storageurl = res.data.path) :
					this.$message.error("视频上传失败，请重新上传！");
			},
			// 删除视频
			handleRemove() {
				this.videoForm.storageurl = [];
			},
			// 上传图片
			handleAvatarSuccess(res, file, list) {
				this.imageUrl = res.data.path;
				this.form.video_img = this.imageUrl;

				//   this.form.sales_img = this.imageUrl;
				//   console.log(this.imageUrl);
			},
			beforeAvatarUpload(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpeg" ||
					file.type === "image/gif" ||
					file.type === "image/webp";
				const isLt2M = file.size / 1024 / 1024 < 1000;

				if (!isJPG) {
					this.$message.error("图片格式不对");
				}
				return isJPG;
			},
			// 获取分类数组
			getclassifyLists() {
				getclassifyList().then((res) => {
					this.classArr = res.data.records;
					console.log(this.classArr, 111)
				});
			},
			// 获取小区分类
			getcommunityLists() {
				const form = {
					select: 1,
				};
				getcommunityList(form).then((res) => {
					this.xiaoquArr = res.data.records;
					let jsonArray = JSON.stringify(this.xiaoquArr);
					let jsonArrays = JSON.parse(jsonArray);
					let arr = {
						id: 0,
						title: "通用",
					};
					jsonArrays.unshift(arr);
					let newXiaoarr = JSON.stringify(jsonArrays);
					// this.communityData = JSON.parse(newXiaoarr);
					this.communityData = JSON.parse(newXiaoarr).map(({
						id,
						title
					}) => ({
						id,
						title,
					}));
				});
			},
			// 重置
			reset() {
				this.form = {
					status: undefined,
					title: undefined,
				};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.form.type = 1;
					this.form.status = 1;
					this.imageUrl = "";
					this.videoForm.storageurl = "";
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				if (this.form.xiaoqu_id) {
					const stt = this.form.xiaoqu_id.split(",").map(Number);
					this.form.xiaoqu_id = stt;
				}
				if (this.form.category_ids) {
					const stt = this.form.category_ids.split(",").map(Number);
					this.form.category_ids = stt;
				}
				if (this.form.suit_time_begin && this.form.suit_time_end) {
					this.form.sy_date = [this.form.suit_time_begin, this.form.suit_time_end];
				}
				if (this.form.tag_ids) {
					const stts = this.form.tag_ids.split(",").map(Number);
					this.form.tag_ids = stts;
				}
				this.$nextTick(() => {
					this.imageUrl = row.video_img;
					this.videoForm.storageurl = row.url;
					this.$forceUpdate();
				});
				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				this.$refs["form"].validate((vaild, err) => {
					if (vaild) {
						delete this.form.article_imgs;
						delete this.form.xiaoqu_name;

						if (this.form.sy_date.length) {
							this.form.suit_time_begin = this.form.sy_date[0];
							this.form.suit_time_end = this.form.sy_date[1];
							delete this.form.sy_date;
						}

						const str = this.form.category_ids.join(",");
						this.form.category_ids = str;
						if (this.form.xiaoqu_id) {
							const str = this.form.xiaoqu_id.join(",");
							this.form.xiaoqu_id = str;
						}
						if (this.form.tag_ids) {
							const strs = this.form.tag_ids.join(",");
							this.form.tag_ids = strs;
						}
						this.form.url = this.videoForm.storageurl;
						delete this.form.created_at;
						this.submitForm();
					}
				});
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.imageUrl = undefined;
				this.videoForm.storageurl = "";
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.imageUrl = undefined;
				this.videoForm.storageurl = "";
				this.$refs.form.clearValidate();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 40vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/information/video.vue